export interface ProductPreview {
  src: string
  label: string
  alt: string
}

export const productPreviews: ProductPreview[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/5ocjrD7BduWopKHNvyhnq4/Captura_de_pantalla_2026-10-11_124651.png',
    label: 'Visual Technique Breakdown',
    alt: 'Knees, hips, torso and shoulders — relaxed structure breakdown page',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/iGYykuvtxa8VPazJVAsV2w/Captura_de_pantalla_2026-10-11_124242.png',
    label: 'Step-by-Step Progression',
    alt: 'Hip-shoulder connection — sequenced rotation from hips to torso to shoulder',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/64XREdbHoVp5wBfvo3mZgK/Captura_de_pantalla_2026-10-11_124154.png',
    label: 'Ready-to-Use Boxing Drill',
    alt: 'Unit 1 correct distance — three ranges on the heavy bag drill page',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4fYAPGrPmoaK1fMAVa1pg9/Captura_de_pantalla_2026-10-11_124634.png',
    label: 'Mistakes & Corrections',
    alt: 'Weight distribution — balanced base vs front-heavy vs rear-heavy comparison',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2Ay4yb7QRhGFyju89dqWuo/Captura_de_pantalla_2026-10-11_124507.png',
    label: 'Coaching Framework',
    alt: 'Ring geography — tactical map of center, open space, rope line, corners and lanes',
  },
]
